import React, { Fragment, useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { CSVLink } from "react-csv";
import { NavLink } from 'react-router-dom';
import QuestionListItem from './QuestionListItem';
import Conversations from './Conversations';
import moment from 'moment';
import {
  AxiosAPI,
  getGroupID,
  AxiosPublicAPI,
} from '../../../../../helpers/AxiosAPI';
import { gAPI_Conversations_By_Id } from '../../../../../constants/APIs';
import IntlMessages from '../../../../../helpers/IntlMessages';

const STOPFB_URL = process.env.REACT_APP_CHAT_API + '/stopfb';
const RESUMEFB_URL = process.env.REACT_APP_CHAT_API + '/resumefb';

const UserQuestions = ({ allData, data, loadMore, isLoading, fromDate, toDate }) => {
  const [loading, setLoading] = useState(false);
  const [transfertobot, setTransfertobot] = useState(false);
  const [transfertomesseger, setTransfertomesseger] = useState(false);
  const [selectedChat, setselectedChat] = useState();
  const [showButton, setShowButton] = useState(false);
  const [csvData, setCSVData] = useState([]);
  useEffect(() => {
    const tablePrint = [
      { r1: "Recent Queries", r2: "", r3: "" },
      { r1: "Start Date", r2: fromDate, r3: "" },
      { r1: "End Date", r2: toDate, r3: "" },
      { r1: "", r2: "", r3: "" },
      { r1: "Conversation ID", r2: "Text", r3: "Time" },
    ];

    if (allData && allData.length > 0) {
      allData.forEach((chat) => {
        tablePrint.push({
          r1: chat?.conversationId,
          r2: chat?.text,
          r3: moment(chat?.time).format('DD/MM/YYYY h:mm a'),
        });
      });
    }

    setCSVData(tablePrint);
  }, [allData, fromDate, toDate]);

  const handleContactClick = (index, conversationId) => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Conversations_By_Id}/${conversationId}?gid=${getGroupID()}`,
    })
      .then((response) => {
        setConversationVisible(true);
        setselectedChat(response.data);
      })
      .catch((error) => error);
  };
  const [conversationVisible, setConversationVisible] = useState(false);

  // const handleScroll = (e) => {
  //   const bottom =
  //     e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight ||
  //     e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight === 1;
  //   if (bottom && data.length > 0) {
  //     setShowButton(true);
  //   }
  // };
  const toggleMessanger = () => {
    setTransfertomesseger(!transfertomesseger);
  };

  const togglebot = () => {
    setTransfertobot(!transfertobot);
  };
  const StopFacebookChat = (botConversationId) => {
    // console.log(botConversationId)
    AxiosPublicAPI({
      method: 'get',
      url: `${STOPFB_URL}/${botConversationId}`,
    }).then((userData) => {
      console.log('stop FB');
      toggleMessanger();
    });
  };

  const ResumeFacebookChat = (botConversationId) => {
    AxiosPublicAPI({
      method: 'get',
      url: `${RESUMEFB_URL}/${botConversationId}`,
    }).then((userData) => {
      console.log('resume FB');
      togglebot();
    });
  };
  const TransferBotToMessanger = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={transfertomesseger}
                keyboard="false"
                backdrop="static"
                toggle={toggleMessanger}
              >
                <ModalHeader>Handover to Messenger</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will stop responding to the user messages, and you
                    will need to respond from the Facebook Messenger app. You
                    can anytime give control back to the chatbot for this
                    Facebook user.{' '}
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={toggleMessanger}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const TransferToBot = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={transfertobot}
                keyboard="false"
                backdrop="static"
                toggle={togglebot}
              >
                <ModalHeader>Handover to Chatbot</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will start responding to this user messages. You can
                    anytime take control back from the chatbot for this Facebook
                    user.
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={togglebot}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const ConversationButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1"></Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  const toggleConversation = () => {
    setConversationVisible(!conversationVisible);
  };
  return (
    <Fragment>

      <Card>
        <div style={{ padding: '15px' }}>
          <div className='float-right'>
            <CSVLink
              data={csvData}
              headers={[
                { key: "r1", label: "" },
                { key: "r2", label: "" },
                { key: "r3", label: "" }
              ]}
              filename={`recent-queries-${fromDate}-to-${toDate}.csv`}
            >

              <Button
                color="primary"
                outline
                size="xs"
                disabled={!allData || allData.length === 0}
              >
                <IntlMessages id='dashboards.download' />
              </Button>
            </CSVLink>
          </div>

          <div className="float-left float-none-xs">
            <div className="d-inline-block">
              <h5 className="d-inline">
                {/* <IntlMessages id="dashboards.visitor-questions" />  */}
                <IntlMessages id="dashboards.recent-queries" />
              </h5>
              <span className="text-muted text-small d-block">
                <IntlMessages id="dashboards.visitor-saying" />
              </span>
            </div>
          </div>
        </div>
        <CardBody style={{ height: 375, overflowY: 'scroll' }}>
          <div className="scroll">
            {!isLoading ? (
              data?.length > 0 && (
                <div>
                  <div>
                    {data.map((chat, index) => {
                      return (
                        <QuestionListItem
                          key={`chat_${index}`}
                          item={chat}
                          handleClick={handleContactClick}
                        />
                      );
                    })}
                  </div>
                </div>
              )
            ) : (
              <div className="loading" />
            )}
          </div>
          {loading && (
            <div
              style={{ textAlign: 'center', fontSize: '16px', margin: '8px 0' }}
            >
              Loading ...
            </div>
          )}
          {data?.length >= 10 && (
            <Button
              style={{ margin: '8px 0', float: 'right' }}
              color="primary"
              size="sm"
              onClick={loadMore}
            >
              More
            </Button>
          )}
        </CardBody>
      </Card>
      {conversationVisible === true && (
        <Modal
          isOpen={conversationVisible}
          toggle={toggleConversation}
          size="lg"
        >
          <ModalHeader toggle={toggleConversation}>
            Conversation & Visitor Details
          </ModalHeader>
          <ModalBody>
            {selectedChat !== undefined && selectedChat !== null && (
              <Conversations
                selectedChat={selectedChat}
                StopFacebookChat={StopFacebookChat}
                ResumeFacebookChat={ResumeFacebookChat}
              />
            )}
          </ModalBody>
        </Modal>
      )}
      {TransferBotToMessanger()}
      {TransferToBot()}
    </Fragment>
  );
};
export default UserQuestions;
